import template from './floors-count-house.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.floorsCountHouse', [])
    .directive('cianAfAboutObjectFloorsCountHouse', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.floorsMin = 1;
            this.floorsMax = 999;

            this.validation = validation(this.form, 'floorsCountHouse', {
                parse: 'Введите число',
                min: 'Количество этажей должено быть больше 0',
                max: 'Допустимо не более 3 символов',
            });
        },
        controllerAs: 'floorsCountHouse',
        template,
    }))
    .name;
